/* Theme: NovaCommerce | © 2026 Akshar Group Technologies | All Rights Reserved */
(function () {
  const html = document.documentElement;
  const loader = document.getElementById('ThemeLoadingOverlay');
  const header = document.querySelector('.nova-header');

  function hideLoader() {
    if (!loader) return;
    loader.classList.add('is-hidden');
    window.setTimeout(function () {
      if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
    }, 220);
  }

  if (document.readyState === 'complete') {
    hideLoader();
  } else {
    window.addEventListener('load', hideLoader, { once: true });
  }

  // Some templates may include hidden BOM text nodes at section boundaries.
  // Remove those nodes to prevent phantom vertical gaps above the header.
  ['shopify-section-announcement-bar', 'shopify-section-header'].forEach(function (id) {
    const section = document.getElementById(id);
    if (!section) return;
    Array.prototype.slice.call(section.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && (!node.nodeValue || node.nodeValue.replace(/\uFEFF/g, '').trim() === '')) {
        section.removeChild(node);
      }
    });
  });

  if (header && header.dataset.stickyEnabled === 'true') {
    function updateStickyState() {
      if (window.scrollY > 10) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    }
    updateStickyState();
    window.addEventListener('scroll', updateStickyState, { passive: true });
  }

  function toggleState(trigger, target, className) {
    if (!trigger || !target) return;
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    target.classList.toggle(className);
  }

  const mobileTrigger = document.querySelector('[data-mobile-menu-trigger]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');

  if (mobileTrigger && mobileMenu) {
    mobileTrigger.addEventListener('click', function () {
      toggleState(mobileTrigger, mobileMenu, 'is-open');
      if (mobileOverlay) mobileOverlay.classList.toggle('is-open');
      html.classList.toggle('overflow-hidden');
    });
  }

  if (mobileOverlay && mobileTrigger && mobileMenu) {
    mobileOverlay.addEventListener('click', function () {
      mobileTrigger.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('is-open');
      mobileOverlay.classList.remove('is-open');
      html.classList.remove('overflow-hidden');
    });
  }

  const cartDrawerDisabled = true;
  const cartTriggers = qsa('[data-cart-drawer-trigger]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartClose = document.querySelector('[data-cart-close]');

  function setCartTriggerExpanded(expanded) {
    cartTriggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function openCartDrawer() {
    if (cartDrawerDisabled) {
      window.location.href = '/cart';
      return;
    }
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    setCartTriggerExpanded(true);
    html.classList.add('overflow-hidden');
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    setCartTriggerExpanded(false);
    html.classList.remove('overflow-hidden');
  }

  if (cartDrawerDisabled && cartTriggers.length) {
    cartTriggers.forEach(function (cartTrigger) {
      cartTrigger.removeAttribute('data-cart-drawer-trigger');
    });
  }

  if (!cartDrawerDisabled && cartTriggers.length && cartDrawer && cartOverlay) {
    cartTriggers.forEach(function (cartTrigger) {
      cartTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        openCartDrawer();
      });
    });
  }

  if (!cartDrawerDisabled) {
    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  }

  function money(cents, currencyCode) {
    const amount = Number(cents || 0) / 100;
    const activeCurrency = currencyCode
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || 'GBP';

    if (window.Intl && typeof window.Intl.NumberFormat === 'function') {
      try {
        return new window.Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: activeCurrency
        }).format(amount);
      } catch (error) {}
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const format = window.Shopify.money_format || '£{{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }

    return '£' + amount.toFixed(2);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function updateCartCountBadges(itemCount) {
    const badges = qsa('[data-cart-count-badge]');
    badges.forEach(function (badge) {
      if (itemCount > 0) {
        badge.hidden = false;
        badge.textContent = String(itemCount);
      } else {
        badge.hidden = true;
      }
    });
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer || !cart) return;

    const countEl = qs('[data-cart-drawer-count]', cartDrawer);
    if (countEl) countEl.textContent = String(cart.item_count || 0);

    const itemsEl = qs('[data-cart-items]', cartDrawer);
    if (itemsEl) {
      if (!cart.items || !cart.items.length) {
        itemsEl.innerHTML = '<p class="text-sm text-slate-500">Your cart is empty.</p>';
      } else {
        const rows = cart.items.map(function (item, index) {
          const line = index + 1;
          const key = escapeHtml(item.key || '');
          const title = escapeHtml(item.product_title || item.title || 'Product');
          const url = escapeHtml(item.url || '#');
          const img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + title + '" class="h-full w-full object-cover">' : '';
          return (
            '<li class="cart-drawer-card flex gap-3 p-2.5">' +
            '  <a href="' + url + '" class="h-20 w-20 shrink-0 overflow-hidden rounded-md bg-slate-50">' + img + '</a>' +
            '  <div class="min-w-0 flex-1">' +
            '    <a href="' + url + '" class="line-clamp-2 text-sm font-semibold text-slate-800 hover:text-brand">' + title + '</a>' +
            '    <div class="cart-drawer-qty mt-3 inline-flex items-center overflow-hidden border border-slate-300">' +
            '      <button type="button" class="px-2.5 py-1 text-base text-slate-600 hover:bg-slate-100" data-cart-action="decrease" data-cart-line="' + line + '" data-cart-key="' + key + '" data-cart-qty="' + item.quantity + '" aria-label="Decrease quantity">-</button>' +
            '      <span class="min-w-8 px-2 text-center text-xs font-semibold text-slate-700">' + item.quantity + '</span>' +
            '      <button type="button" class="px-2.5 py-1 text-base text-slate-600 hover:bg-slate-100" data-cart-action="increase" data-cart-line="' + line + '" data-cart-key="' + key + '" data-cart-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
            '    </div>' +
            '    <div class="mt-2 flex items-center justify-between">' +
            '      <p class="text-sm font-bold text-slate-900">' + money(item.final_line_price, cart.currency) + '</p>' +
            '      <button type="button" class="text-xs font-semibold text-rose-600 hover:underline" data-cart-action="remove" data-cart-line="' + line + '" data-cart-key="' + key + '" aria-label="Remove item">Remove</button>' +
            '    </div>' +
            '  </div>' +
            '</li>'
          );
        }).join('');
        itemsEl.innerHTML = '<ul class="space-y-3" role="list">' + rows + '</ul>';
      }
    }

    const subtotalEl = qs('[data-cart-subtotal]', cartDrawer);
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price || 0, cart.currency);

    updateCartCountBadges(cart.item_count || 0);
  }

  async function fetchCartState() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  }

  async function changeCartLine(payload) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    const cart = await response.json().catch(function () { return null; });
    if (!response.ok) {
      const message = cart && (cart.description || cart.message) ? (cart.description || cart.message) : 'Failed to update cart';
      throw new Error(message);
    }
    if (!cartDrawerDisabled) {
      renderCartDrawer(cart);
      if ((cart.item_count || 0) === 0) closeCartDrawer();
    } else {
      window.location.href = '/cart';
    }
    return cart;
  }

  async function addToCartFromForm(form) {
    const submitBtn = qs('[type="submit"]', form);
    const originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    try {
      const formData = new FormData(form);
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: formData
      });

      if (!addResponse.ok) {
        throw new Error('Failed to add item to cart');
      }

      const cart = await fetchCartState();
      if (!cartDrawerDisabled) {
        renderCartDrawer(cart);
        openCartDrawer();
      }
      if (submitBtn) {
        submitBtn.textContent = 'Added';
        window.setTimeout(function () {
          if (submitBtn) submitBtn.textContent = originalText;
        }, 1000);
      }
      updateCartCountBadges(cart.item_count || 0);
    } catch (error) {
      window.alert('Could not add this item to cart. Please try again.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        if (submitBtn.textContent !== 'Added') submitBtn.textContent = originalText;
      }
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (!cartDrawerDisabled) closeCartDrawer();
      if (mobileMenu && mobileTrigger && mobileOverlay) {
        mobileMenu.classList.remove('is-open');
        mobileOverlay.classList.remove('is-open');
        mobileTrigger.setAttribute('aria-expanded', 'false');
        html.classList.remove('overflow-hidden');
      }
    }
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form[data-ajax-atc], form.product-card-form');
    if (!form) return;

    const variantInput = qs('[name="id"]', form);
    if (!variantInput) return;

    event.preventDefault();
    addToCartFromForm(form);
  });

  if (!cartDrawerDisabled && cartDrawer) {
    cartDrawer.addEventListener('click', function (event) {
      const actionBtn = event.target.closest('[data-cart-action]');
      if (!actionBtn) return;
      if (cartDrawer.dataset.cartUpdating === 'true') return;

      event.preventDefault();
      const key = actionBtn.getAttribute('data-cart-key') || '';
      const line = parseInt(actionBtn.getAttribute('data-cart-line') || '0', 10);
      const qty = parseInt(actionBtn.getAttribute('data-cart-qty') || '0', 10);
      if (!key && !line) return;

      let nextQty = qty;
      const action = actionBtn.getAttribute('data-cart-action');
      if (action === 'increase') nextQty = qty + 1;
      if (action === 'decrease') nextQty = Math.max(0, qty - 1);
      if (action === 'remove') nextQty = 0;

      const payload = key ? { id: key, quantity: nextQty } : { line: line, quantity: nextQty };

      cartDrawer.dataset.cartUpdating = 'true';
      changeCartLine(payload)
        .catch(function (error) {
          fetchCartState()
            .then(function (cart) { if (!cartDrawerDisabled) renderCartDrawer(cart); })
            .catch(function () {});
          window.alert(error && error.message ? error.message : 'Could not update cart item. Please try again.');
        })
        .finally(function () {
          delete cartDrawer.dataset.cartUpdating;
        });
    });
  }

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function initMegaHeaderSearch() {
    qsa('[data-mega-search-live]').forEach(function (form) {
      if (form.dataset.megaSearchInit === 'true') return;
      form.dataset.megaSearchInit = 'true';

      const input = qs('[data-mega-search-input]', form);
      const panel = qs('[data-mega-search-suggest]', form);
      const status = qs('[data-mega-search-status]', form);
      const list = qs('[data-mega-search-list]', form);
      const viewAll = qs('[data-mega-search-view-all]', form);
      if (!input || !panel || !status || !list || !viewAll) return;

      let debounceTimer = null;
      let activeIndex = -1;

      function closePanel() {
        panel.hidden = true;
        activeIndex = -1;
      }

      function openPanel() {
        panel.hidden = false;
      }

      function updateViewAllLink(query) {
        const url = new URL(form.getAttribute('action') || '/search', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        viewAll.setAttribute('href', url.pathname + url.search);
      }

      function renderItems(products, query) {
        list.innerHTML = '';
        activeIndex = -1;

        if (!products.length) {
          status.textContent = 'No products found';
          viewAll.hidden = false;
          updateViewAllLink(query);
          openPanel();
          return;
        }

        status.textContent = products.length + (products.length === 1 ? ' product found' : ' products found');
        products.forEach(function (product) {
          const item = document.createElement('a');
          item.className = 'mega-search-suggest-item';
          item.href = product.url;

          const thumb = product.featured_image && product.featured_image.url
            ? '<img class="mega-search-suggest-item-thumb" src="' + product.featured_image.url + '&width=84" alt="' + escapeHtml(product.title || '') + '">'
            : '<span class="mega-search-suggest-item-thumb" aria-hidden="true"></span>';

          const meta = [];
          if (product.vendor) meta.push(escapeHtml(product.vendor));
          if (product.price && product.price > 0) meta.push(money(product.price));

          item.innerHTML =
            thumb +
            '<span>' +
            '  <span class="mega-search-suggest-item-title">' + escapeHtml(product.title || 'Product') + '</span>' +
            '  <span class="mega-search-suggest-item-meta">' + meta.join(' • ') + '</span>' +
            '</span>';
          list.appendChild(item);
        });

        viewAll.hidden = false;
        updateViewAllLink(query);
        openPanel();
      }

      async function fetchSuggestions(query) {
        const url = new URL('/search/suggest.json', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');

        const response = await fetch(url.toString(), {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Search request failed');

        const payload = await response.json();
        return payload && payload.resources && payload.resources.results && payload.resources.results.products
          ? payload.resources.results.products
          : [];
      }

      input.addEventListener('input', function () {
        const query = input.value.trim();
        if (debounceTimer) window.clearTimeout(debounceTimer);

        if (!query) {
          list.innerHTML = '';
          status.textContent = 'Type to search products';
          viewAll.hidden = true;
          closePanel();
          return;
        }

        debounceTimer = window.setTimeout(async function () {
          status.textContent = 'Searching...';
          openPanel();
          try {
            const products = await fetchSuggestions(query);
            renderItems(products, query);
          } catch (e) {
            status.textContent = 'Could not load suggestions';
            list.innerHTML = '';
            viewAll.hidden = false;
            updateViewAllLink(query);
            openPanel();
          }
        }, 220);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim()) openPanel();
      });

      input.addEventListener('keydown', function (event) {
        const items = qsa('.mega-search-suggest-item', list);
        if (!items.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activeIndex = Math.min(items.length - 1, activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activeIndex = Math.max(0, activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          window.location.href = items[activeIndex].href;
          return;
        } else if (event.key === 'Escape') {
          closePanel();
          return;
        } else {
          return;
        }

        items.forEach(function (item, index) {
          item.classList.toggle('is-active', index === activeIndex);
        });
      });

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) closePanel();
      });
    });
  }

  function createQuickViewModal() {
    const existing = qs('[data-nova-quick-view-modal]');
    if (existing) return existing;

    const modal = document.createElement('div');
    modal.setAttribute('data-nova-quick-view-modal', '');
    modal.className = 'nova-qv-modal';
    modal.innerHTML =
      '<div class="nova-qv-backdrop" data-nova-qv-close></div>' +
      '<div class="nova-qv-dialog" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '  <button type="button" class="nova-qv-close" data-nova-qv-close aria-label="Close quick view">' +
      '    <span aria-hidden="true">×</span>' +
      '  </button>' +
      '  <div class="nova-qv-body" data-nova-qv-body></div>' +
      '</div>';

    document.body.appendChild(modal);

    function close() {
      modal.classList.remove('is-open');
      html.classList.remove('overflow-hidden');
      const body = qs('[data-nova-qv-body]', modal);
      if (body) body.innerHTML = '';
    }

    qsa('[data-nova-qv-close]', modal).forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    modal._novaClose = close;
    return modal;
  }

  async function openQuickView(productUrl) {
    if (!productUrl) return;
    const modal = createQuickViewModal();
    const body = qs('[data-nova-qv-body]', modal);
    modal.classList.add('is-open');
    html.classList.add('overflow-hidden');

    if (body) {
      body.innerHTML =
        '<div class="p-8 text-sm text-slate-600">Loading…</div>';
    }

    try {
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('section_id', 'quick-view');
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      const htmlText = await res.text();
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');
      const section = doc.querySelector('.shopify-section');
      if (body) body.innerHTML = section ? section.innerHTML : htmlText;
      const qvRoot = body ? qs('.nova-qv', body) : null;
      const dialog = modal ? qs('.nova-qv-dialog', modal) : null;
      if (qvRoot && dialog) {
        const maxWidth = qvRoot.getAttribute('data-qv-max-width');
        if (maxWidth) {
          dialog.style.width = 'min(' + maxWidth + 'px, 92vw)';
        }
      }
    } catch (e) {
      if (body) {
        body.innerHTML =
          '<div class="p-8 text-sm text-red-600">Could not load quick view.</div>';
      }
    }
  }

  document.addEventListener('click', function (event) {
    const quickViewBtn = event.target.closest('[data-nova-quick-view]');
    if (quickViewBtn) {
      event.preventDefault();
      openQuickView(quickViewBtn.getAttribute('data-nova-quick-view'));
    }
  });

  document.addEventListener('shopify:section:load', function () {
    initNovaCarousels();
    initMegaHeaderSearch();
  });

  initMegaHeaderSearch();

  function initNovaCarousels() {
    qsa('[data-nova-carousel]').forEach(function (root) {
      if (root.dataset.novaCarouselInit === 'true') return;
      root.dataset.novaCarouselInit = 'true';

      const track = qs('[data-nova-carousel-track]', root);
      if (!track) return;

      let prev = qs('[data-nova-carousel-prev]', root);
      let next = qs('[data-nova-carousel-next]', root);
      let dots = qs('[data-nova-carousel-dots]', root);
      const autoplay = root.getAttribute('data-autoplay') === 'true';
      const intervalMs = parseInt(root.getAttribute('data-interval') || '4500', 10);
      let pagePoints = [0];
      let slides = [];

      function ensureControls() {
        const hasArrows = !!(prev && next);
        if (!hasArrows) {
          const arrowWrap = document.createElement('div');
          arrowWrap.className = 'mt-3 flex items-center justify-end gap-2';

          const prevBtn = document.createElement('button');
          prevBtn.type = 'button';
          prevBtn.className = 'nova-icon-btn';
          prevBtn.setAttribute('data-nova-carousel-prev', '');
          prevBtn.setAttribute('aria-label', 'Previous slide');
          prevBtn.innerHTML = '<svg class="h-5 w-5 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>';

          const nextBtn = document.createElement('button');
          nextBtn.type = 'button';
          nextBtn.className = 'nova-icon-btn';
          nextBtn.setAttribute('data-nova-carousel-next', '');
          nextBtn.setAttribute('aria-label', 'Next slide');
          nextBtn.innerHTML = '<svg class="h-5 w-5 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>';

          arrowWrap.appendChild(prevBtn);
          arrowWrap.appendChild(nextBtn);
          root.appendChild(arrowWrap);
          prev = prevBtn;
          next = nextBtn;
        }

        if (!dots) {
          const dotsWrap = document.createElement('div');
          dotsWrap.className = 'mt-4 flex items-center justify-center gap-2';
          dotsWrap.setAttribute('data-nova-carousel-dots', '');
          dotsWrap.setAttribute('aria-label', 'Carousel pagination');
          root.appendChild(dotsWrap);
          dots = dotsWrap;
        }
      }

      ensureControls();

      function getPagePoints() {
        slides = qsa('[data-nova-carousel-slide]', track);
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (!slides.length || maxScroll <= 2) return [0];

        const points = [];

        slides.forEach(function (slide) {
          const point = Math.max(0, Math.min(maxScroll, slide.offsetLeft - track.offsetLeft));
          if (!points.length || Math.abs(points[points.length - 1] - point) > 2) {
            points.push(point);
          }
        });

        if (!points.length) {
          return [0];
        }

        if (Math.abs(points[0]) > 2) {
          points.unshift(0);
        } else {
          points[0] = 0;
        }

        if (Math.abs(points[points.length - 1] - maxScroll) > 2) {
          points.push(maxScroll);
        } else {
          points[points.length - 1] = maxScroll;
        }

        return points;
      }

      function closestPageIndex() {
        const current = track.scrollLeft;
        let bestIdx = 0;
        let bestDist = Number.POSITIVE_INFINITY;
        pagePoints.forEach(function (x, i) {
          const d = Math.abs(current - x);
          if (d < bestDist) {
            bestDist = d;
            bestIdx = i;
          }
        });
        return bestIdx;
      }

      function scrollToX(x) {
        track.scrollTo({ left: x, behavior: 'smooth' });
      }

      function scrollByPage(dir) {
        pagePoints = getPagePoints();
        const currentIdx = closestPageIndex();
        const targetIdx = Math.max(0, Math.min(pagePoints.length - 1, currentIdx + dir));
        scrollToX(pagePoints[targetIdx]);
      }

      if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
      if (next) next.addEventListener('click', function () { scrollByPage(1); });

      function buildDots() {
        if (!dots) return;
        dots.innerHTML = '';

        pagePoints = getPagePoints();
        if (pagePoints.length <= 1) {
          dots.style.display = 'none';
          return;
        }
        dots.style.display = '';

        for (let i = 0; i < pagePoints.length; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'nova-carousel-dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function () {
            scrollToX(pagePoints[i]);
          });
          dots.appendChild(b);
        }
      }

      function updateDots() {
        if (!dots) return;
        const buttons = qsa('button', dots);
        if (!buttons.length) return;
        const idx = closestPageIndex();
        buttons.forEach(function (b, i) {
          b.classList.toggle('is-active', i === idx);
          b.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }

      function updateArrows() {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft >= maxScroll - 2;
        const isSinglePage = pagePoints.length <= 1;

        if (prev) {
          prev.classList.toggle('is-disabled', isSinglePage || atStart);
          prev.disabled = isSinglePage || atStart;
        }
        if (next) {
          next.classList.toggle('is-disabled', isSinglePage || atEnd);
          next.disabled = isSinglePage || atEnd;
        }
      }

      function refreshCarousel(preservePosition) {
        const currentIdx = preservePosition ? closestPageIndex() : 0;
        buildDots();
        if (preservePosition && pagePoints[currentIdx] != null) {
          track.scrollLeft = pagePoints[currentIdx];
        }
        updateDots();
        updateArrows();
      }

      refreshCarousel(false);

      track.addEventListener('scroll', function () {
        window.clearTimeout(track._novaScrollT);
        track._novaScrollT = window.setTimeout(function () {
          updateDots();
          updateArrows();
        }, 50);
      }, { passive: true });

      window.addEventListener('resize', function () {
        refreshCarousel(true);
      });

      window.requestAnimationFrame(function () {
        refreshCarousel(true);
      });

      window.setTimeout(function () {
        refreshCarousel(true);
      }, 120);

      qsa('img', track).forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          refreshCarousel(true);
        }, { once: true });
        img.addEventListener('error', function () {
          refreshCarousel(true);
        }, { once: true });
      });

      if (autoplay) {
        let t = window.setInterval(function () {
          const max = track.scrollWidth - track.clientWidth;
          pagePoints = getPagePoints();
          const currentIdx = closestPageIndex();
          const nextIdx = currentIdx >= pagePoints.length - 1 ? 0 : currentIdx + 1;
          scrollToX(Math.min(max, pagePoints[nextIdx] || 0));
        }, Math.max(1500, intervalMs));

        root.addEventListener('mouseenter', function () { window.clearInterval(t); });
        root.addEventListener('mouseleave', function () {
          t = window.setInterval(function () {
            const max = track.scrollWidth - track.clientWidth;
            pagePoints = getPagePoints();
            const currentIdx = closestPageIndex();
            const nextIdx = currentIdx >= pagePoints.length - 1 ? 0 : currentIdx + 1;
            scrollToX(Math.min(max, pagePoints[nextIdx] || 0));
          }, Math.max(1500, intervalMs));
        });
      }
    });
  }

  initNovaCarousels();

  fetchCartState()
    .then(function (cart) {
      if (!cartDrawerDisabled) renderCartDrawer(cart);
      updateCartCountBadges(cart.item_count || 0);
    })
    .catch(function () {
      updateCartCountBadges(0);
    });
})();
